import React from "react";
import { createRoot } from "react-dom/client";
import "./assets/index";
import { Main } from "./main";
import { QueryProvider } from "./QueryProvider";
const root = createRoot(document.getElementById("root"));
root.render(React.createElement(QueryProvider, null,
    React.createElement(Main, null)));
